import { render, staticRenderFns } from "./ContractTermsBuilderCreate.vue?vue&type=template&id=cd21d5e0&"
import script from "./ContractTermsBuilderCreate.vue?vue&type=script&lang=js&"
export * from "./ContractTermsBuilderCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports